<template src="./Contact.html"></template>
<style lang="scss" scoped src="./Contact.scss"></style>

<script>
import {
  SfBreadcrumbs,
  SfButton,
  SfSelect,
  SfHeading,
  SfInput,
  SfTextarea,
  SfNotification,
  SfIcon
} from "@storefront-ui/vue"
import Api from "@/api/Api";
import Icons from "@/utils/icons";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";

export default {
  name: "Contact",
  components: {
    OrkRecaptcha,
    SfBreadcrumbs,
    SfButton,
    SfHeading,
    SfInput,
    SfIcon,
    SfSelect,
    SfTextarea,
    SfNotification
  },

  data() {
    return {
      icons: Icons,
      locale: this.$i18n.locale,
      valid: false,
      submitted: false,
      email: "",
      emailBlur: true,
      subject: "",
      orderReference: "",
      message: "",
      messageBlur: true,
      notification: {isVisible: false, message: "", type: "success"},
      breadcrumbs: [{
        text: this.$t('Home'),
        link: '/'
      }, {
        text: this.$t('Contact'),
        link: ''
      }]
    }
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptcha.execute()
    },
    validate() {
      this.emailBlur = false
      this.messageBlur = false
      if (
          this.validEmail(this.email) &&
          this.validMessage(this.message)
      ) {
        this.valid = true
      }
    },
    validEmail(email) {

      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    validMessage(message) {
      return !!message && message.length > 10 && message.length <= 400
    },
    submitForm(token) {
      this.validate()

      if (this.valid) {


        Api.platform.submitContactForm({
          orderReference: this.orderReference,
          email: this.email,
          subject: this.subject,
          message: this.message,
          recaptchaData: token
        })
            .then(() => {
                  this.submitted = true;

                  this.notification = {
                    isVisible: true,
                    message: this.$i18n.t('contactForm.notifications.success'),
                    type: 'success'
                  }
                  this.emailBlur = true
                  this.messageBlur = true
                  this.email = "";
                  this.orderReference = "";
                  this.subject = "";
                  this.message = "";
                }
            )
            .catch((e) => {
                  let error = '';
                  switch (e.status) {
                    case 401:
                      error = this.$i18n.t('errors.unauthorized')
                      break;
                    case 404:
                      error = this.$i18n.t('errors.notFound')
                      break;
                    case 500:
                      error = this.$i18n.t('errors.server.access')
                      break;
                    case -1:
                      error = this.$i18n.t('errors.connexion')
                      break;
                  }
                  this.notification = {
                    isVisible: true,
                    message: error,
                    type: 'danger',
                    icon: 'error'
                  }
                  this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
                  this.submitted = true
                }
            )
            .finally()
      }
    },

    reset() {
      this.emailBlur = true
      this.messageBlur = true
      this.email = "";
      this.orderReference = "";
      this.subject = "";
      this.message = "";
      this.notification.isVisible = false;
    },
  },
}
</script>
